import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { LandlineBannerStore } from 'entities/Phone/ui/LandlineBanner/store/landlineBannerStore'

export const LandlineBanner = observer(() => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new LandlineBannerStore(entities))
  const { show, init, dispose, initBanner } = store

  useEffect(() => {
    init()

    return () => {
      dispose()
    }
  }, [])

  useEffect(() => {
    initBanner()
  }, [show])

  return null
})
